const Policy = () =>
  import(
    /* webpackChunkName: "base-info-financial-policy" */ '@/pages/base-info/financial/policy/index.vue'
  )
const CreatePolicy = () =>
  import(
    /* webpackChunkName: "base-info-financial-policy" */ '@/pages/base-info/financial/policy/create.vue'
  )
const EditPolicy = () =>
  import(
    /* webpackChunkName: "base-info-financial-policy" */ '@/pages/base-info/financial/policy/edit.vue'
  )

export default {
  path: 'policy',
  meta: {
    label: 'policy',
    auth: 'policy'
  },
  component: {
    name: 'Policy',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoFinancialPolicy',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Policy
    },
    {
      name: 'BaseInfoCreateFinancialPolicy',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreatePolicy
    },
    {
      name: 'BaseInfoEditFinancialPolicy',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditPolicy,
      props: true
    }
  ]
}
